import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tab, Tabs } from '@ds';

const TABS = [{ key: 'notifications', label: 'NOTIFICATIONS', path: 'notifications' }] as const;

export const Settings = () => {
  /* Add in future feature */
  // const theme = useUiSettingsStore((state) => state.theme);
  // const switchTheme = useUiSettingsStore((state) => state.switchTheme);

  // const onThemeChange = () => {
  //   const isLight = theme === 'light';

  //   switchTheme(isLight ? 'dark' : 'light');
  // };
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = TABS.find((t) => location.pathname.includes(`/profile/settings/${t.path}`)) ?? TABS[0];

  const handleTabChange = (key: string | number) => {
    const tab = TABS.find((t) => t.key === key);
    if (!tab) return;
    navigate(tab.path);
  };

  return (
    <div className="min-h-full bg-base-80 flex flex-1 flex-col">
      <div className="pt-6">
        <h1 className="text-4xl font-semibold text-black mb-6 px-6">Settings</h1>

        <Tabs
          aria-label="Settings Tabs"
          variant="underlined"
          selectedKey={currentTab.key}
          onSelectionChange={handleTabChange}
          classNames={{
            tabContent: 'text-s-m px-4',
            base: 'w-full px-3 border-b border-base-60',
            tabList: 'p-0 gap-8',
          }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.key} title={tab.label} />
          ))}
        </Tabs>
      </div>
      {/* Add in future feature */}
      {/* <CommonInformationBoard header="UI Settings">
        <div className="flex items-center gap-3">
          <span className="text-l-m text-base-5">Light Mode</span>
          <TmdxSwitch
            size="lg"
            color="default"
            isSelected={theme === 'dark'}
            showStartContent
            showEndContent
            onValueChange={onThemeChange}
          />
          <span className="text-l-m text-base-5">Dark Mode</span>
        </div>
      </CommonInformationBoard> */}
      <div className="flex flex-1 p-6">
        <Outlet />
      </div>
    </div>
  );
};
